module.exports = __webpack_public_path__ + "img/kihei.13f2a108.jpg";